import { Box, Stack, Text } from '@mantine/core';

import { NavLink } from 'react-router-dom';

const IndexCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '16px',
            }}>
            <Text ta={'center'}>{rowData.pdpContext?.index}</Text>
        </Box>
    );
};

const IndexColumn = () => ({
    accessorKey: 'pdpcontext.index',
    header: 'PDP Context',
    size: 1,
    Cell: ({ cell }) => <IndexCell cell={cell} />,
});
export default IndexColumn;
